import { mui, React, ts, ui } from '_core';

import { ConstraintScope } from '@finsera/finsera/dist/resource/optimizer';

type SignalFactorType = ts.types.pipeline.NeutralizeDraft['factors'][0] & { scope?: ConstraintScope };

type SignalProps = {
  value: SignalFactorType;
  setValue: (_value: SignalFactorType) => void;
  isBasket?: boolean;
};

const Signal = ({ value, setValue, isBasket }: SignalProps) => {
  return (
    <mui.core.Stack gap={3}>
      <ui.ResourceAutocomplete<ts.types.signal.SignalExpanded, false, true>
        value={value.value}
        chooseHandle
        setValue={(handle) => setValue({ ...value, value: handle })}
        type="signal_based"
        inputProps={{
          label: 'Signal / Alpha Model',
          variant: 'outlined',
          size: 'small',
          required: true,
        }}
      />
      <ui.ResourceAutocomplete<ts.types.pipeline.PipelineExpanded>
        value={value.pipeline_id}
        setValue={(id) => {
          setValue({ ...value, pipeline_id: id });
        }}
        type={ts.enums.RESOURCES_TYPES_ENUM.PIPELINE}
        inputProps={{
          label: 'Pipeline',
          variant: 'outlined',
          size: 'small',
        }}
        enableNone
      />
      <ui.ResourceAutocomplete<ts.types.pipeline.PipelineExpanded>
        value={value.sp_pipeline_id}
        enableNone
        setValue={(id) => setValue({ ...value, sp_pipeline_id: id })}
        type="sp_pipeline"
        inputProps={{
          label: 'Portfolio Pipeline',
          variant: 'outlined',
          size: 'small',
        }}
      />
      {isBasket && (
        <mui.core.TextField
          select
          label="Scope"
          variant="outlined"
          size="small"
          sx={{ minWidth: 'fit-content' }}
          value={value.scope || 'ANY'}
          onChange={(e) => {
            const newScope = e.target.value as ConstraintScope;
            setValue({ ...value, scope: newScope });
          }}
          fullWidth
          required
        >
          <mui.core.MenuItem value={'ANY'}>All Positions</mui.core.MenuItem>
          <mui.core.MenuItem value={'LONG'}>Long Only</mui.core.MenuItem>
          <mui.core.MenuItem value={'SHORT'}>Short Only</mui.core.MenuItem>
        </mui.core.TextField>
      )}
    </mui.core.Stack>
  );
};

export default Signal;
